import tw from "tailwind-styled-components"

export const Title = tw.h2`text-2md font-tbcx-bold text-[18px] mt-5 px-5`
export const Text = tw.p`text-sm border-top-width-0 font-xs py-3 px-5 text-[#7F8396] `
export const MainDiv = tw.div`flex items-center`
export const GridDiv = tw.div`grid grid-cols-3 grid-rows-3 gap-1 px-2`
